import { Component } from '@angular/core';
import { AuthService } from './core/auth/auth.service';
import { Events } from './core/events';
import { AuthEvents } from './core/auth/auth-events';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {

  private authStartup: Promise<any>;

  constructor(
    public auth: AuthService,
    private events: Events) {
    this.initializeApp();
  }

  private initializeApp() {
    this.listenToLoginEvents();
  }

  listenToLoginEvents() {
    this.events.subscribe(AuthEvents.USER_SIGNIN, () => {

    });

    this.events.subscribe(AuthEvents.USER_SIGNUP, () => {

    });

    this.events.subscribe(AuthEvents.USER_LOGOUT, () => {

    });

    this.events.subscribe(AuthEvents.USER_UNAUTHORIZED, () => {

    });
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/app.component.ts